export const siteSettings = {
  name: "Nadex Live Trading",
  link: "https://nadexlivetrading.com",
  email: "support@nadexlivetrading.com",
  appLink: "https://app.nadexlivetrading.com",
};
